var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 6.37499H9.20842V4.95832H7.79175M8.50008 14.1667C5.37633 14.1667 2.83341 11.6237 2.83341 8.49999C2.83341 5.37624 5.37633 2.83332 8.50008 2.83332C11.6238 2.83332 14.1667 5.37624 14.1667 8.49999C14.1667 11.6237 11.6238 14.1667 8.50008 14.1667ZM8.50008 1.41666C7.56989 1.41666 6.6488 1.59987 5.78941 1.95584C4.93002 2.31181 4.14916 2.83357 3.49141 3.49132C2.16303 4.8197 1.41675 6.62137 1.41675 8.49999C1.41675 10.3786 2.16303 12.1803 3.49141 13.5087C4.14916 14.1664 4.93002 14.6882 5.78941 15.0441C6.6488 15.4001 7.56989 15.5833 8.50008 15.5833C10.3787 15.5833 12.1804 14.837 13.5088 13.5087C14.8371 12.1803 15.5834 10.3786 15.5834 8.49999C15.5834 7.56979 15.4002 6.64871 15.0442 5.78932C14.6883 4.92993 14.1665 4.14907 13.5088 3.49132C12.851 2.83357 12.0701 2.31181 11.2108 1.95584C10.3514 1.59987 9.43028 1.41666 8.50008 1.41666ZM7.79175 12.0417H9.20842V7.79166H7.79175V12.0417Z",
    fill: "#002857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.d8e81c956eb6e11c6e88f72b6cbb6d8c.svg";
export { ForwardRef as ReactComponent };